/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_Go_HomeInputs */

const en_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Home`)
};

const es_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

const fr_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

const de_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Startseite`)
};

const ja_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホームへ戻る`)
};

const zh_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

const ar_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة للرئيسية`)
};

const id_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke Beranda`)
};

const it_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla Home`)
};

const ru_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На главную`)
};

const pt_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar para o Início`)
};

const ko_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈으로 가기`)
};

/**
* | output |
* | --- |
* | "Go Home" |
*
* @param {Not_Found_Go_HomeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const not_found_go_home = /** @type {((inputs?: Not_Found_Go_HomeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_Go_HomeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_found_go_home(inputs)
	if (locale === "es") return es_not_found_go_home(inputs)
	if (locale === "fr") return fr_not_found_go_home(inputs)
	if (locale === "de") return de_not_found_go_home(inputs)
	if (locale === "ja") return ja_not_found_go_home(inputs)
	if (locale === "zh") return zh_not_found_go_home(inputs)
	if (locale === "ar") return ar_not_found_go_home(inputs)
	if (locale === "id") return id_not_found_go_home(inputs)
	if (locale === "it") return it_not_found_go_home(inputs)
	if (locale === "ru") return ru_not_found_go_home(inputs)
	if (locale === "pt") return pt_not_found_go_home(inputs)
	return ko_not_found_go_home(inputs)
});